import React, { useState } from "react";
import styled from "styled-components";
import { colors } from "app/popleads/components/ui-kit/colors";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import { FormattedNumber } from "react-intl";
import { useExtensionContext } from "../ExtensionContext";
import { toast } from "react-toastify";
import { DEAL_WON, POPUP_CONTENTS, publicTypes } from "../utils/constants";
import Modal from "app/popleads/components/ui-kit/Modal";

export const ExtensionNewDealFooter = styled.div`
    width: 100%;
    min-height: 32px;
    background-color: #fff;
    border-radius: 0 0 8px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    border-top: 1px solid ${colors.neutral[100]};
`;

const Footer = ({ target, transferDeal, transferDealLoading }) => {
    const {
        dealObject,
        handleCreateDeal,
        handleCreateInquiry,
        profile,
        olanakEkleLoading,
        isDealEditing,
        setIsDealEditing,
        popupContent,
        setState,
        selectedDeal,
    } = useExtensionContext();

    const [showTransferConfirm, setShowTransferConfirm] = useState(false);

    const handleClick = () => {
        if (
            buttonText === "Add" &&
            publicTypes.includes(dealObject.dealCampaignType) &&
            !profile.email &&
            !profile?.email2
        ) {
            toast.error("Profile has no email.");
            return;
        }

        if (popupContent === "Transfer Deal") {
            setShowTransferConfirm(true);
        } else if (
            dealObject.dealCampaignType === "In-house" ||
            dealObject.dealCampaignType === "LVT In-house" ||
            dealObject.dealCampaignType === "Learning Journey"
        ) {
            if (dealObject.selectedInquiry === null) {
                if (dealObject.newInquiry === false) {
                    toast.error("You need to select or create an inquiry");
                    return;
                } else {
                    handleCreateInquiry();
                }
            } else handleCreateInquiry();
        } else if (
            dealObject.dealCampaignType === "EdTech" ||
            dealObject.dealCampaignType === "Consulting" ||
            dealObject.dealCampaignType === "Coaching" ||
            dealObject.dealCampaignType === "E-Learning"
        ) {
            handleCreateInquiry();
        } else {
            if (!profile.sirket) {
                toast.error("You need to enter the company info for the profile.");
                return;
            }
            handleCreateDeal();
        }
    };

    const handleTransferDeal = () => {
        transferDeal(dealObject.id, target, profile.id);
        setShowTransferConfirm(false);
    };

    function generateButtonText({ isLoading, isTransferDeal, dealObject, DEAL_WON }) {
        if (isLoading) {
            return "Loading...";
        }
        if (isTransferDeal) {
            return "Transfer Deal";
        }
        const specialCampaignTypes = [
            "EdTech",
            "Consulting",
            "Coaching",
            "E-Learning",
            "In-house",
            "LVT In-house",
            "Learning Journey",
        ];
        const hasInquiry = dealObject.newInquiry || dealObject.selectedInquiry;
        const isSpecialCampaign = specialCampaignTypes.includes(dealObject.dealCampaignType);
        if (hasInquiry || isSpecialCampaign) {
            return dealObject.toBe === DEAL_WON ? "Save" : "Create Inquiry";
        }
        const excludedCampaignTypes = ["Public", "LVT Public", "Public-ExEd", "Self-Paced", "L&D Broker"];
        const isExcludedCampaign = excludedCampaignTypes.includes(dealObject.dealCampaignType);
        if (!isExcludedCampaign && dealObject.toBe === DEAL_WON && dealObject.id) {
            return "Save";
        }
        return "Add";
    }

    const isLoading = olanakEkleLoading || transferDealLoading;
    const isTransferDeal = popupContent === "Transfer Deal";

    const buttonText = generateButtonText({
        isLoading,
        isTransferDeal,
        dealObject,
        DEAL_WON,
    });

    return (
        <>
            <ExtensionNewDealFooter>
                <div>
                    {popupContent !== "Transfer Deal" && (
                        <>
                            <div style={{ fontSize: "12px", color: colors.neutral[600] }}>Total Amount</div>
                            <div style={{ fontSize: "14px", color: colors.success[900], fontWeight: "500" }}>
                                {dealObject.amount ? (
                                    <>
                                        {" "}
                                        $
                                        <FormattedNumber
                                            minimumFractionDigits={0}
                                            maximumFractionDigits={2}
                                            value={dealObject.amount}
                                        />
                                    </>
                                ) : (
                                    "-"
                                )}
                            </div>
                        </>
                    )}
                </div>
                <div style={{ display: "flex", gap: "8px" }}>
                    {(isDealEditing || popupContent === POPUP_CONTENTS.NEW_DEAL || isTransferDeal) && (
                        <ButtonWithText
                            disabled={olanakEkleLoading}
                            variant="danger"
                            size="small"
                            buttonStyle="borderless"
                            onClick={() => {
                                if (isDealEditing) {
                                    setIsDealEditing(false);
                                }
                                if (popupContent === POPUP_CONTENTS.NEW_DEAL) {
                                    setState((prevState) => ({
                                        ...prevState,
                                        popupContent: selectedDeal ? POPUP_CONTENTS.DEALS : null,
                                        popupIsOpen: !!selectedDeal,
                                    }));
                                }
                                if (isTransferDeal) {
                                    setState((prevState) => ({
                                        ...prevState,
                                        popupContent: selectedDeal ? POPUP_CONTENTS.DEALS : null,
                                        popupIsOpen: !!selectedDeal,
                                    }));
                                }
                            }}
                        >
                            Cancel
                        </ButtonWithText>
                    )}
                    <ButtonWithText
                        disabled={olanakEkleLoading || transferDealLoading}
                        variant="l3rnTech"
                        size="small"
                        buttonStyle="default"
                        onClick={handleClick}
                        leftIcon={olanakEkleLoading ? "loader" : null}
                    >
                        {buttonText}
                    </ButtonWithText>
                </div>
            </ExtensionNewDealFooter>
            <Modal
                isOpen={showTransferConfirm}
                onClose={() => setShowTransferConfirm(false)}
                title="Transfer Deal"
                successButtonText="Yes"
                cancelButtonText="No"
                onSuccess={handleTransferDeal}
            >
                <div>Are you sure you want to transfer this deal?</div>
            </Modal>
        </>
    );
};

export default Footer;
